import { http } from '../index';
import { PostData, query_params } from '../helpers/params';

const getCards = ({url,loader})=>{
  return http.get({
    url: url,
    loader:loader
  });
}

const deposit =({url,params,loader})=>{
  return http.post({
    url: url,
    data: PostData(params),
    loader:loader
  });
}
const withdraw = ({url,params,loader})=>{
  return http.post({
    url: url,
    data: PostData(params),
    loader:loader
  });
}

const deleteCard = ({url,loader})=>{
  return http.post({
    url: url,
    loader:loader
  });
}

const firstDeposit = ({url, loader}) => {
  return http.post({
    url: url,
    loader:loader
  });
}


export default {
  getCards,
  deposit,
  withdraw,
  deleteCard,
  firstDeposit
}
